/**
 * Abstract-like base class for Store Managers.
 * In TypeScript, we can define this as an abstract class to ensure
 * subclasses implement the required methods.
 */
abstract class StoreManager {
    /**
     * Persists data to the storage medium.
     * @param data - The data to save.
     */
    abstract save(data: Record<string, any>): void;

    /**
     * Retrieves data from the storage medium.
     * @returns The retrieved data object.
     */
    abstract load(): Record<string, any>;
}

export default StoreManager;
